module.exports = __webpack_public_path__ + "static/img/honor-swiper-3.ceaf299.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/honor-swiper-3.png
// module id = 7ux9
// module chunks = 1